import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress global 'Script error.' from 3rd party ads to prevent React error overlay
window.onerror = function (msg, url, line, col, error) {
  if (msg === 'Script error.' || (url && (url.includes('untimely-hello.com') || url.includes('annoyingnightmareedit.com')))) {
    return true; // Prevents the firing of the default event handler
  }
};

window.addEventListener('error', (e) => {
  if (e.message === 'Script error.' || !e.filename || e.filename.includes('untimely-hello.com') || e.filename.includes('annoyingnightmareedit.com')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
